/**
 * jQuery
 */
window.$ = window.jQuery = require('jquery');

/**
 * Bootstrap
 */
require('bootstrap');

/**
 * Fancybox
 */
require('@fancyapps/fancybox');

/**
 * Swiper
 */
require('swiper');

require('bootstrap-input-spinner/src/bootstrap-input-spinner');

require('isotope-layout/dist/isotope.pkgd');

require('jquery.maskedinput/src/jquery.maskedinput');

require('bootstrap4-tagsinput/tagsinput');

require('lite-youtube-embed/src/lite-yt-embed');


/**
 *  Owl slider
 */
require('owl.carousel/dist/owl.carousel.min');

/**
 * Get files from /resources/js/public
 */
var req = require.context('./public', true, /^(.*\.(js$))[^.]*$/im);
req.keys().forEach(function(key) {
    req(key);
});
